// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__5qyPK","header":"Card_header__bzCly","headerText":"Card_headerText__1KJYs"};